var map = {
	"./groupAffiliatesController.js": 1092,
	"./groupController.js": 9238,
	"./groupGamesController.js": 1374,
	"./groupGamesItemController.js": 1157,
	"./groupMembersListController.js": 8987,
	"./groupStoreController.js": 3869,
	"./groupWallController.js": 7221,
	"./leaveGroupController.js": 2379,
	"./reportAbuseController.js": 7626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5927;